import {Component, h, Method, Event, Prop, Element} from '@stencil/core';
import type {StrategyData} from './types/strategy-data.type';
import {makeLogger} from '../../logger/logger';


const {err, warn} = makeLogger({pathToCurrentFile: 'components/strategies/uiaas-search-strategies.tsx'});

@Component({
  tag: 'uiaas-search-strategies',
})

export class UiaasSearchStrategies {

    @Prop({mutable: true}) composedStrategy;

    /**
     * Receives data in JSON
     */
    @Prop() readonly strategy: string;

    @Element() el;

    @Method() async setStrategyFor(name: string, callback:CallableFunction):Promise<void> {
        this.composedStrategy[name] = {
          ...this.composedStrategy[name],
          customStrategy: callback
        };
    }

    @Event({
      eventName: 'strategies:ready',
      composed: true,
      cancelable: true,
      bubbles: true,
    }) ready;

    private parseStrategyJSON = (strategyJson: string):StrategyData | null => {
        try {
          return JSON.parse(strategyJson);
        } catch(e) {
          err('Unable to parse strategy',{
            exception: e,
            providedInput: strategyJson
          });
          return null;
        }

    };

    private aggregatedStrategyData = {};

    private aggregateStrategies = (element: HTMLElement): void => {
        const closestStrategyElement = element.parentElement.closest('uiaas-search-strategies');
        const parsedOwnStrategy = this.strategy ? this.parseStrategyJSON(this.strategy) : {};

        if (closestStrategyElement) {
          const parsedFirstParentStrategy = closestStrategyElement.strategy ? this.parseStrategyJSON(closestStrategyElement.strategy) : {};
          this.aggregatedStrategyData = {
            ...parsedFirstParentStrategy,
            ...this.aggregatedStrategyData,
            ...parsedOwnStrategy
          };
          this.aggregateStrategies(closestStrategyElement);
        } else {
          this.composedStrategy = {
            ...this.aggregatedStrategyData,
            ...parsedOwnStrategy
          };
        }
    };

    connectedCallback() {
        if (!this.strategy) {
          warn('One of your strategy components has unset strategy property. ' +
              'Fallback strategy was applied for this component. Check your strategies structure in DOM tree');
        } else {
          this.aggregateStrategies(this.el);
        }
    }

    componentWillLoad() {
        if(this.composedStrategy) {
          return;
        }

        if (!this.strategy) {
          warn('One of your strategy components has unset strategy property. ' +
        'Fallback strategy was applied for this component. Check your strategies structure in DOM tree');
        } else {
          this.aggregateStrategies(this.el);
        }
    }

    componentDidLoad() {
        this.ready.emit();
    }

    render() {
        return <slot/>;
    }
}
